"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyConfirmNoKnowLossHistory = exports.ClaimHistoryRecord = void 0;
const utils_1 = require("@loadsure/utils");
const losses_class_1 = __importDefault(require("./losses.class"));
class ClaimHistoryRecord {
    constructor(data) {
        this.year = data.year;
        this.totalGrossLosses = data.totalGrossLosses;
        this.numberOfLosses =
            typeof data.numberOfLosses === "string"
                ? parseInt(data.numberOfLosses, 10)
                : data.numberOfLosses;
    }
    isValid() {
        return ((this.year &&
            utils_1.isNumber(this.totalGrossLosses) &&
            this.totalGrossLosses === 0) ||
            (this.year &&
                utils_1.isNumber(this.totalGrossLosses) &&
                this.totalGrossLosses &&
                utils_1.isNumber(this.numberOfLosses) &&
                this.numberOfLosses &&
                this.numberOfLosses < 999));
    }
    static fromObj(data) {
        return new ClaimHistoryRecord({
            year: data.year,
            totalGrossLosses: data.totalGrossLosses,
            numberOfLosses: data.numberOfLosses
        });
    }
    static getRecords(data) {
        if (!Array.isArray(data)) {
            throw Error("claim history must be a list");
        }
        return data.map((record) => ClaimHistoryRecord.fromObj(record));
    }
}
exports.ClaimHistoryRecord = ClaimHistoryRecord;
const emptyConfirmNoKnowLossHistory = () => ({
    confirmed: false,
    confirmedBy: ""
});
exports.emptyConfirmNoKnowLossHistory = emptyConfirmNoKnowLossHistory;
exports.default = losses_class_1.default;
//# sourceMappingURL=index.js.map